import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import 'react-responsive-modal/styles.css';
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from 'react-i18next';
import { ColorRing } from "react-loader-spinner";
import Table from 'react-bootstrap/Table';
import dateformat from "dateformat";
import ReactPaginate from "react-paginate";

const GetTeamBusiness = (props: any) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState('');
    const [btnDisable, setbtnDisable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState({ trade: 0, compound: 0, total: 0 });
    const [allHistory, setAllHistory] = useState([]);
    const [page, setpage] = useState(1);
    const [limit, setLimit] = useState(100);
    const [keyCount, setKeyCount] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const GetTeamTrade = async () => {
        setLoading(true);
        setbtnDisable(true);
        let data = {
            "startdate": startDate,
            "enddate": endDate,
        }

        let res = await _fetch(`${api_url}report/team-trade-fund`, "POST", data);

        if (res?.status === 'success') {
            setLoading(false);
            setbtnDisable(false);
            setAllData(res?.data?.summary);
            setAllHistory(res?.data?.users);
            setTotalRecords(res?.data?.totalRecords);
        }
        else {
            toasted.error(res?.message);
            setLoading(false);
            setbtnDisable(false);
        }
        if (page > 1) {
            setKeyCount(0);
            var count = page - 1;
            setKeyCount(count * limit);
        }
    }


    const handlePageClick = async (event: any) => {
        const newOffset = (event.selected + 1);
        setpage(newOffset);
    };

    return (
        <>
            <main>
                <div className="buy_section loader_main">
                    {loading &&
                        <div className="spinner_bg">
                            <div className="color_ring">  <ColorRing
                                visible={true}
                                height="80"
                                width="80"
                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                            />
                            </div>
                        </div>
                    }
                    <div className="coustom_container">
                        <div className="buy_top_sec">
                            <h4>
                                {t("TRADE BUSINESS")}
                            </h4>
                            <div className="inner_data">
                                <p className="">{t("Trade")} : ${allData?.trade}</p>
                                <p className="">{t("Compound")} : ${allData?.compound}</p>
                                <p className="">{t("Total")} : ${allData?.total}</p>
                            </div>
                        </div>
                        <div className="row cards_sec">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card christmas_card mb-4">
                                    <div className="card-body">
                                        <div className="card_bottom_Sec">
                                            <div className="buy-section">
                                                <p className="select_amount">
                                                    <input type="date" placeholder='Enter Start Date' onChange={(e: any) => setStartDate(e.target.value)} value={startDate} />
                                                </p>
                                                <p className="select_amount">
                                                    <input type="date" placeholder='Enter End Date' onChange={(e: any) => setEndDate(e.target.value)} value={endDate} />
                                                </p>
                                                <button className="button_style w-100 mt-3" onClick={() => GetTeamTrade()} disabled={btnDisable}>
                                                    {`${t("Submit")}`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="table_section ">
                        <div className="scrolling_table">
                            <div className="scroll_under">
                                <Table className="support_table">
                                    <thead>
                                        <tr className="table_heading_row">
                                            <th className="table_heading">#</th>
                                            <th className="table_heading">{t("Username")}</th>
                                            <th className="table_heading">{t("Trade")}</th>
                                            <th className="table_heading">{t("Compound")}</th>
                                            <th className="table_heading">{t("Total")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {allHistory?.map((item: any, index: any) => {
                                            return (
                                                <>
                                                    <tr className="table_data_row">
                                                        <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                                                        <td className="table_data"><div className="pic_text">{item?.username}</div> </td>
                                                        <td className="table_data">{item?.trade}</td>
                                                        <td className="table_data">{item?.compound}</td>
                                                        <td className="table_data">{item?.total}</td>
                                                    </tr>
                                                </>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                                {/* {totalRecords > limit && <ReactPaginate className="pagination__2 " activeClassName="active"
                                    breakLabel="..."
                                    nextLabel=">"
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={1}
                                    pageCount={totalRecords / limit}
                                    previousLabel="<" */}
                                {/* />} */}

                            </div>
                        </div>
                    </div>
                </div>
            </main>


        </>
    );
};

export default GetTeamBusiness;
